/**
 * Get Prompt ID for the provided prompt
 * @param {*} prompt prompt object
 * @param {*} isShortId true - language not included, false - language included. short PromptIvr ID is for matching with database records.
 * @returns {String} language_namespace_promptId
 */
export const getPromptIvrId = (prompt, isShortId = false) => {
	const ivrParts = [];
	const { language, namespace, promptId } = prompt;
	if (!isShortId) {
		ivrParts.push("prompt");
		ivrParts.push(language);
	}
	ivrParts.push(namespace);
	ivrParts.push(promptId);
	return ivrParts.filter((a) => a).join("_");
};

export const columnsDefinition = [
	{
		title: "Language",
		field: "language",
		hasSorting: false,
	},
	{
		title: "Namespace",
		field: "namespace",
		hasSorting: false,
	},
	{
		title: "ID",
		field: "promptId",
		hasSorting: true,
	},
	{
		title: "Type",
		field: "type",
		hasSorting: true,
	},
	{
		title: "Prompt",
		field: "prompt",
		hasSorting: true,
	},
];

// check if prompt is a built-in pace prompt
export const isPacePrompt = (prompt) => {
	const pacePromptIds = {
		System: [
			"Warning",
			"Error",
			"Voicemail_Recording_To_Queue_Start_Message",
			"Voicemail_Recording_To_Queue_End_Message",
			"Voicemail_Recording_To_Queue_Error_Message",
			"Voice_To_SMS_Enter_Phone_Number",
			"Voice_To_SMS_Initiate_Process",
			"Voice_To_SMS_Invalid_Phone_Number",
			"Voice_To_SMS_Prompt",
			"Voice_To_SMS_Successful_Transfer",
			"Voice_To_SMS_Use_Current_Or_Entered_Number",
			"Voice_To_SMS_Use_Current_Or_Entered_Number_Retry_Message",
			"Voice_To_SMS_Wait_Message",
		],
		Callbacks: [
			"Ask_AMPM",
			"Ask_Number",
			"Ask_Time",
			"Callback_Confirmed",
			"Confirm_Number",
			"Confirm_Time",
			"Error",
			"Offer_Callback",
			"Offer_Callback_Ewt",
			"Outbound_Callback",
			"Scheduled_Callback_Confirmed",
			"Time_Before_EWT",
			"Time_Past_Closing",
		],
	};

	return pacePromptIds[prompt.namespace] && pacePromptIds[prompt.namespace].includes(prompt.promptId);
};

export const getPromptIndex = (promptsArr, prompt) =>
	promptsArr.findIndex(
		(p) => p.language === prompt.language && p.namespace === prompt.namespace && p.promptId === prompt.promptId,
	);

export const getNameSpaceAndPromptId = (prompt) => {
	const { namespace, promptId } = prompt;
	return namespace ? getPromptIvrId(prompt, true) : promptId;
};
